module.exports = __webpack_public_path__ + "static/media/left_carrot.0d514361.svg";